var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-rich-text-editor",class:{ 'is-disabled': _vm.data.disabled }},[_c('editor',{ref:"toastUiEditor",attrs:{"initial-value":_vm.initialValue,"options":_vm.editorOptions,"height":`${_vm.data.height}px`,"initialEditType":"wysiwyg","previewStyle":"tab"},on:{"change":_vm.onEditorChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }